import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import { canvasToolbarGroupVariants } from "./canvasToolbarStyles";

interface CanvasToolbarGroupProps extends ComponentPropsWithoutRef<"div"> {
  well?: boolean;
}

export function CanvasToolbarGroup({
  well = false,
  className,
  children,
  ...rest
}: CanvasToolbarGroupProps) {
  return (
    <div
      className={cn(canvasToolbarGroupVariants({ well }), className)}
      {...rest}
    >
      {children}
    </div>
  );
}
